import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { environment } from 'src/environments/environment';
import { SaleTargetInfo } from '../model/SaleTargetInfo.model';
import { SaleTeamInfo } from '../model/SaleTeamInfo.model';
import { ProjectSaleInfo } from '../model/projectsale.model';

@Component({
  selector: 'app-sale-report',
  templateUrl: './sale-report.component.html',
  styleUrls: ['./sale-report.component.css']
})
export class SaleReportComponent implements OnInit, AfterViewInit {
  @ViewChild('tableContainer') tableContainer: ElementRef;
  
  // Variables for drag-to-pan functionality
  private isDragging = false;
  private startX: number;
  private startY: number;
  private scrollLeft: number;
  private scrollTop: number;
  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;

  baseurl: string;

  yearOptions: ProjectSaleInfo[] = [];
  quarterOptions: string[] = [];
  monthOptions: { value: string; label: string }[] = [];

  earliestTarget: SaleTargetInfo;

  // Search variables
  periodSearch: string = 'YEAR';
  yearSearch: string = null;
  quarterSearch: string = null;
  monthSearch: string = null;
  txtSearchSaleTeam: string = null;
  txtSearchSaleTeamMember: string = null;

  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];

  // Main Data
  SaleTargetList: SaleTargetInfo[] = [];
  processedEmployeeData: any[] = [];
  processedTeamData: any[] = [];
  processedTeamOnlyData: any[] = [];
  showGrandTotal: boolean = true;
  isSearchSubmitted: boolean = false;

  // Table edit mode properties
  tableEditMode: boolean = false;
  teamTableEditMode: boolean = false;
  editedValues: any = {};
  originalValues: any = {};
  teamEditedValues: any = {};
  teamOriginalValues: any = {};

  // Edit form properties
  editMode: boolean = false;
  selectedTarget: SaleTargetInfo = {
    SaleTargetId: 0,
    SaleTargetTeamCode: '',
    SaleTargetTeamName: '',
    SaleTargetTeamSeq: '',
    SaleTargetEmpCode: '',
    SaleTargetEmpName: '',
    SaleTargetMonth: '',
    SaleTargetQuarter: '',
    SaleTargetYear: '',
    SaleTargetPeriod: 'YEAR',
    SaleTargetAmount: 0,
    SaleTargetActualAmount: 0,
    CreateDate: null,
    CreateBy: '',
    UpdateDate: null,
    UpdateBy: '',
    rowFetch: 0,
    rowOFFSet: 0,
    itemTotal: 0,
    RequesterEmpCode: '',
    SaleTargetFlagNewCust: 'N',
    SaleTargetAssetTypeCode: '',
    SaleTargetAssetTypeName: ''
  };

  IsModalOn = false;

  modalPeriodSelected = "YEAR";

  // Sale Team properties
  selectedTeam: any = null;
  selectedTeamMember: any = null;
  teamOptions: SaleTeamMappingEmployeeInfo[] = [];
  teamMemberOptions: SaleTeamMappingEmployeeInfo[] = [];

  // Zone pagination variable
  public indexNo: number = 0;
  public currentPageNumber: number = 0;
  public totalPages: number = 0;
  public totalItems: number = 0;
  public environment: number = 999999;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
  }

  ngOnInit(): void {
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2) {
      localStorage.setItem("EmpCode", this._ParamEmpCode);
    }

    this.initializeComponent();
  }

  ngAfterViewInit() {
    // Add global event listeners to ensure drag is properly stopped
    // This helps when the mouse is released outside the container
    document.addEventListener('mouseup', this.handleGlobalMouseUp.bind(this));
  }
  
  ngOnDestroy() {
    // Clean up global event listeners
    document.removeEventListener('mouseup', this.handleGlobalMouseUp.bind(this));
  }
  
  // Handle global mouse up to ensure drag is stopped
  handleGlobalMouseUp() {
    if (this.isDragging) {
      this.stopDragging();
    }
  }
  
  // Check if an element is empty or a structural element or if we're clicking on an empty area
  private isEmptyOrStructural(element: HTMLElement, event: MouseEvent): boolean {
    // Check if it's a structural element
    if (['TABLE', 'THEAD', 'TBODY', 'TR'].includes(element.tagName)) {
      return true;
    }
    
    // Check if it's an empty cell
    if ((element.tagName === 'TD' || element.tagName === 'TH') && 
        (!element.textContent || element.textContent.trim() === '')) {
      return true;
    }
    
    // Check if we're clicking on a cell
    if (element.tagName === 'TD' || element.tagName === 'TH') {
      // Get the computed style to check padding
      const style = window.getComputedStyle(element);
      const paddingLeft = parseInt(style.paddingLeft, 10) || 0;
      const paddingRight = parseInt(style.paddingRight, 10) || 0;
      const paddingTop = parseInt(style.paddingTop, 10) || 0;
      const paddingBottom = parseInt(style.paddingBottom, 10) || 0;
      
      // Get the position of the click relative to the element
      const rect = element.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      
      // Check if click is in the padding area
      if (x < paddingLeft || x > rect.width - paddingRight || 
          y < paddingTop || y > rect.height - paddingBottom) {
        return true;
      }
      
      // Check if we're clicking on an empty area within the cell
      // Get the element at the exact click position
      const elementsAtPoint = document.elementsFromPoint(event.clientX, event.clientY);
      
      // If we're on a cell but not directly on text content
      if (elementsAtPoint.length > 1) {
        // Check if there's any text node directly at the click position
        let clickedOnText = false;
        
        // Check if we clicked on a text node by checking all child nodes
        const range = document.createRange();
        const textRects = [];
        
        // Collect all text node rectangles
        const walkTree = (node) => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
            range.selectNodeContents(node);
            const rects = range.getClientRects();
            for (let i = 0; i < rects.length; i++) {
              textRects.push(rects[i]);
            }
          } else if (node.childNodes) {
            for (let i = 0; i < node.childNodes.length; i++) {
              walkTree(node.childNodes[i]);
            }
          }
        };
        
        walkTree(element);
        
        // Check if click is within any text rectangle
        for (const textRect of textRects) {
          if (event.clientX >= textRect.left && event.clientX <= textRect.right &&
              event.clientY >= textRect.top && event.clientY <= textRect.bottom) {
            clickedOnText = true;
            break;
          }
        }
        
        // If we didn't click on text, allow dragging
        if (!clickedOnText) {
          return true;
        }
      }
    }
    
    return false;
  }
  
  // Start dragging when mouse button is pressed
  startDragging(e: MouseEvent) {
    // Only initiate drag with left mouse button (button 0)
    if (!this.tableContainer || e.button !== 0) return;
    
    // Don't start dragging if user is already selecting text
    if (window.getSelection()?.toString()) return;
    
    // Check if we're in a text selection mode (double click or triple click)
    if (e.detail > 1) {
      return; // Let browser handle double/triple clicks for text selection
    }
    
    // Get the target element
    const target = e.target as HTMLElement;
    
    // Only start dragging if we're clicking on an empty area or structural element
    const isEmptyArea = this.isEmptyOrStructural(target, e);
    
    if (!isEmptyArea) {
      // We're clicking on text content, let the browser handle text selection
      return;
    }
    
    // Clear any existing text selection
    if (window.getSelection) {
      window.getSelection()?.removeAllRanges();
    }
    
    // Start dragging
    const container = this.tableContainer.nativeElement;
    this.isDragging = true;
    container.classList.add('dragging');
    this.startX = e.pageX;
    this.startY = e.pageY;
    this.scrollLeft = container.scrollLeft;
    this.scrollTop = container.scrollTop;
    
    // Prevent default to avoid any text selection during drag
    e.preventDefault();
  }
  
  // Handle dragging motion
  onDrag(e: MouseEvent) {
    // Only proceed if we're in dragging mode
    if (!this.isDragging || !this.tableContainer) return;
    
    // Check if the left mouse button is still pressed
    if (e.buttons !== 1) {
      this.stopDragging();
      return;
    }
    
    const container = this.tableContainer.nativeElement;
    e.preventDefault(); // Prevent text selection during drag
    
    // Calculate distance moved
    const x = e.pageX;
    const y = e.pageY;
    const walkX = (this.startX - x) * 2; // Multiply by 2 for faster/more responsive movement
    const walkY = (this.startY - y) * 2;
    
    // Update scroll position
    container.scrollLeft = this.scrollLeft + walkX;
    container.scrollTop = this.scrollTop + walkY;
  }
  
  // Stop dragging when mouse button is released
  stopDragging() {
    if (!this.tableContainer) return;
    
    this.isDragging = false;
    this.tableContainer.nativeElement.classList.remove('dragging');
  }

  async initializeComponent() {
    this.loadInitialData();
  }

  async loadInitialData() {
    await this.loadLeadYears();
    await this.loadQuarterOptions();
    await this.loadMonthOptions();
    await this.loadSaleTeams();
    await this.LoadSaleTarget(true);
  }

  // loadYearOptions() {
  //   const currentYear = new Date().getFullYear();
  //   // Generate years from 5 years ago to 5 years in the future
  //   for (let i = -5; i <= 5; i++) {
  //     this.yearOptions.push((currentYear + i).toString());
  //   }
  //   // Set default year to current year
  //   this.yearSearch = currentYear.toString();
  // }

  async loadQuarterOptions() {
    this.quarterOptions = ['Q1', 'Q2', 'Q3', 'Q4'];
  }

  async loadMonthOptions() {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    this.monthOptions = monthNames.map((name, index) => ({
      value: (index + 1).toString(),
      label: name
    }));
  }

  async loadLeadYears() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      try {
        const result = await this.httpClient.get<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetLeadYears", httpOptions).toPromise();
        if (result && result.length > 0) {
          this.yearOptions = result;
          // Set the default year to the most recent year
          if (this.yearOptions.length >= 2) {
          this.yearSearch = result[result.length - 2].ProjectSaleYear;
          } else {
            this.yearSearch = result[result.length - 1].ProjectSaleYear;
          }
          console.log('Default year set to:', this.yearSearch);
        } else {
          console.error('No years returned from GetLeadYears');
          // Set current year as fallback
          const currentYear = new Date().getFullYear();
          this.yearSearch = currentYear.toString();
        }
      } catch (error) {
        console.error('Error loading years:', error);
        // Set current year as fallback
        const currentYear = new Date().getFullYear();
        this.yearSearch = currentYear.toString();
      }
    }
  }

  async loadSaleTeams() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamList = data

          //console.log(this.SaleTeamList);
        });
    }
  }

  // Determine text color based on comparison between actual and target values
  getComparisonColor(actual: number, target: number): string {
    if (actual < target) {
      return 'red';
    } else if (actual > target) {
      return 'green';
    }
    return ''; // Default color if equal
  }

  async LoadSaleTarget(isNewSearch: boolean = false) {
    if (isNewSearch) {
      this.currentPageNumber = 1;
      this.isSearchSubmitted = true;
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      // Prepare search parameters
      var objectjson = {};
      objectjson['RequesterEmpCode'] = this._EmpCode;
      objectjson['SaleTargetTeamCode'] = this.txtSearchSaleTeam;
      objectjson['SaleTargetEmpCode'] = this.txtSearchSaleTeamMember;
      objectjson['SaleTargetMonth'] = this.monthSearch;
      objectjson['SaleTargetQuarter'] = this.quarterSearch;
      objectjson['SaleTargetYear'] = this.yearSearch;
      //objectjson['SaleTargetFlagNewCust'] = 'N'; // Only get target values

      this.httpClient.post<SaleTargetInfo[]>(this.baseurl + "SaleTarget/GetSaleTargetActuals", objectjson, httpOptions)
        .subscribe(result => {
          console.log('API Response:', result);
          this.SaleTargetList = result;
          this.processData();
        }, error => console.error('API Error:', error));
      
      }
    
  }

  processData() {
    console.log('Starting processData with SaleTargetList:', this.SaleTargetList);
    
    // Group data by team and employee
    const teamMap = new Map();
    const teamOnlyMap = new Map();
    const allEmployees = [];
    
    // First pass: organize data by team and employee
    // We'll process all records but separate them by SaleTargetFlagNewCust
    let filteredTargets = this.SaleTargetList;
    
    // Apply additional filtering based on selected team
    if (this.txtSearchSaleTeam) {
      console.log('Filtering by team:', this.txtSearchSaleTeam);
      filteredTargets = filteredTargets.filter(target => target.SaleTargetTeamCode === this.txtSearchSaleTeam);
      // Hide grand total when a specific team is selected
      this.showGrandTotal = false;
    } else {
      // Show grand total when no team is selected
      this.showGrandTotal = true;
    }
    
    // Apply additional filtering based on selected team member
    if (this.txtSearchSaleTeamMember) {
      console.log('Filtering by team member:', this.txtSearchSaleTeamMember);
      filteredTargets = filteredTargets.filter(target => target.SaleTargetEmpCode === this.txtSearchSaleTeamMember);
    }
    
    console.log('Filtered targets after all filters:', filteredTargets);
    
    filteredTargets.forEach(target => {
      const teamCode = target.SaleTargetTeamCode;
      const empCode = target.SaleTargetEmpCode;
      
      // Determine period based on available data
      let period = target.SaleTargetPeriod;
      if (!period) {
        if (target.SaleTargetMonth) {
          period = 'MONTH';
        } else if (target.SaleTargetQuarter) {
          period = 'QUARTER';
        } else if (target.SaleTargetYear) {
          period = 'YEAR';
        }
      }
      
      const targetAmount = target.SaleTargetAmount || 0;
      const actualAmount = target.SaleTargetActualAmount || 0;
      
      console.log(`Processing target: Team=${teamCode}, Emp=${empCode}, Period=${period}, Target=${targetAmount}, Actual=${actualAmount}`, target);

      // Initialize team if not exists
      if (!teamMap.has(teamCode)) {
        teamMap.set(teamCode, {
          teamCode,
          teamName: target.SaleTargetTeamName,
          employees: []
        });
      }

      // Initialize team-only data if not exists
      if (!teamOnlyMap.has(teamCode)) {
        teamOnlyMap.set(teamCode, {
          teamCode,
          teamName: target.SaleTargetTeamName,
          target: {
            months: Array(12).fill(0),
            quarters: Array(4).fill(0),
            year: 0
          },
          actual: {
            months: Array(12).fill(0),
            quarters: Array(4).fill(0),
            year: 0
          }
        });
      }

      // If this is a team-level entry (no employee code)
      if (!empCode) {
        const teamData = teamOnlyMap.get(teamCode);
        
        if (period === 'MONTH' && target.SaleTargetMonth) {
          const monthIndex = parseInt(target.SaleTargetMonth) - 1;
          if (monthIndex >= 0 && monthIndex < 12) {
            // Set target value
            teamData.target.months[monthIndex] = targetAmount;
            // Set actual value
            teamData.actual.months[monthIndex] = actualAmount;
          }
        } else if (period === 'QUARTER' && target.SaleTargetQuarter) {
          const quarterIndex = parseInt(target.SaleTargetQuarter.replace('Q', '')) - 1;
          if (quarterIndex >= 0 && quarterIndex < 4) {
            // Set target value
            teamData.target.quarters[quarterIndex] = targetAmount;
            // Set actual value
            teamData.actual.quarters[quarterIndex] = actualAmount;
          }
        } else if (period === 'YEAR') {
          // Set target value
          teamData.target.year = targetAmount;
          // Set actual value
          teamData.actual.year = actualAmount;
        }
        return; // Skip the rest for team-level entries
      }

      // Find or create employee in the team
      const team = teamMap.get(teamCode);
      let employee = team.employees.find(emp => emp.empCode === empCode);

      if (!employee) {
        employee = {
          empCode,
          empName: target.SaleTargetEmpName,
          teamCode,
          target: {
            months: Array(12).fill(0),
            quarters: Array(4).fill(0),
            year: 0
          },
          actual: {
            months: Array(12).fill(0),
            quarters: Array(4).fill(0),
            year: 0
          },
          targetNew: {
            months: Array(12).fill(0),
            quarters: Array(4).fill(0),
            year: 0
          },
          actualNew: {
            months: Array(12).fill(0),
            quarters: Array(4).fill(0),
            year: 0
          }
        };
        team.employees.push(employee);
        allEmployees.push(employee);
      }

      // Update employee data based on target period and SaleTargetFlagNewCust
      const isNewCustomer = target.SaleTargetFlagNewCust === 'Y';
      
      if (period === 'MONTH' && target.SaleTargetMonth) {
        const monthIndex = parseInt(target.SaleTargetMonth) - 1;
        if (monthIndex >= 0 && monthIndex < 12) {
          if (isNewCustomer) {
            // Set new customer target value
            employee.targetNew.months[monthIndex] = targetAmount;
            // Set new customer actual value
            employee.actualNew.months[monthIndex] = actualAmount;
          } else {
            // Set old customer target value
            employee.target.months[monthIndex] = targetAmount;
            // Set old customer actual value
            employee.actual.months[monthIndex] = actualAmount;
          }
        }
      } else if (period === 'QUARTER' && target.SaleTargetQuarter) {
        const quarterIndex = parseInt(target.SaleTargetQuarter.replace('Q', '')) - 1;
        if (quarterIndex >= 0 && quarterIndex < 4) {
          if (isNewCustomer) {
            // Set new customer target value
            employee.targetNew.quarters[quarterIndex] = targetAmount;
            // Set new customer actual value
            employee.actualNew.quarters[quarterIndex] = actualAmount;
          } else {
            // Set old customer target value
            employee.target.quarters[quarterIndex] = targetAmount;
            // Set old customer actual value
            employee.actual.quarters[quarterIndex] = actualAmount;
          }
        }
      } else if (period === 'YEAR') {
        if (isNewCustomer) {
          // Set new customer target value
          employee.targetNew.year = targetAmount;
          // Set new customer actual value
          employee.actualNew.year = actualAmount;
        } else {
          // Set old customer target value
          employee.target.year = targetAmount;
          // Set old customer actual value
          employee.actual.year = actualAmount;
        }
      }
    });

    // Second pass: calculate team totals
    teamMap.forEach(team => {
      // Initialize team totals
      team.target = {
        months: Array(12).fill(0),
        quarters: Array(4).fill(0),
        year: 0
      };
      team.actual = {
        months: Array(12).fill(0),
        quarters: Array(4).fill(0),
        year: 0
      };

      // Sum up employee data for this team
      team.employees.forEach(employee => {
        // Sum up months
        for (let i = 0; i < 12; i++) {
          team.target.months[i] += employee.target.months[i] + (employee.targetNew?.months[i] || 0);
          team.actual.months[i] += employee.actual.months[i] + (employee.actualNew?.months[i] || 0);
        }
        // Sum up quarters
        for (let i = 0; i < 4; i++) {
          team.target.quarters[i] += employee.target.quarters[i] + (employee.targetNew?.quarters[i] || 0);
          team.actual.quarters[i] += employee.actual.quarters[i] + (employee.actualNew?.quarters[i] || 0);
        }
        // Sum up year
        team.target.year += employee.target.year + (employee.targetNew?.year || 0);
        team.actual.year += employee.actual.year + (employee.actualNew?.year || 0);
      });
    });

    // Convert team map to array for template rendering
    this.processedTeamData = Array.from(teamMap.values());

    // remove team with no employee
    this.processedTeamData = this.processedTeamData.filter(team => team.employees.length > 0);
    
    // Convert team-only map to array for grand total calculations
    this.processedTeamOnlyData = Array.from(teamOnlyMap.values());

    console.log('Final processed team data:', this.processedTeamData);
    console.log('Final processed team-only data:', this.processedTeamOnlyData);
    this.processedEmployeeData = allEmployees;
    console.log('Final processed employee data:', this.processedEmployeeData);
  }

  isSearchButtonDisabled(): boolean {
    // Validate search criteria based on selected period
    if (this.periodSearch === 'YEAR') {
      return !this.yearSearch;
    } else if (this.periodSearch === 'QUARTER') {
      return !this.yearSearch || !this.quarterSearch;
    } else if (this.periodSearch === 'MONTH') {
      return !this.yearSearch || !this.monthSearch;
    }
    return false;
  }

  resetSearch() {
    this.periodSearch = 'YEAR';
    this.yearSearch = new Date().getFullYear().toString();
    this.quarterSearch = null;
    this.monthSearch = null;
    this.txtSearchSaleTeam = null;
    this.txtSearchSaleTeamMember = null;
  }

}
